import gql from 'graphql-tag'

export const removeExamTaskAssignment = gql`
  mutation removeExamTaskAssignment(
    $examTaskIds: [ID],
    $userId: ID
  ) {
    removeExamTaskAssignment(
      examTaskIds: $examTaskIds,
      userId: $userId
    ) {
      status
      examTasksAssignment {
        examTaskIds
        userId
      }
    }
  }
`
